import React from 'react';
import { Star, Flame, Heart, Zap } from 'lucide-react';
import CustomS from './CustomS';

const BackgroundIcon = ({ iconIndex }: { iconIndex: number }) => {
  const icons = [CustomS, Star, Flame, Heart, Zap];
  const IconComponent = icons[iconIndex % icons.length];

  if (!IconComponent) return null;

  return (
    <div
      className="absolute right-0 top-0 opacity-[0.06] z-0 pointer-events-none"
      style={{ transform: 'translateX(20px)' }}
    >
      <IconComponent size={200} strokeWidth={1.5} fill="currentColor" />
    </div>
  );
};

export default BackgroundIcon;
